<script setup>
const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
})

const imageSource = computed(() => {
  const validImages = props.product.images.filter(img => img.image && img.image.url)
  if (validImages.length > 0) {
    return validImages[validImages.length - 1].image.url
  }
  return null
})

const isPriceRange = computed(() => {
  return props.product?.price_range?.max?.decimal !== props.product?.price_range?.min?.decimal
})

function addToCart() {
  emit('add-to-cart', props.product.id)
}

const { t } = useI18n()
</script>

<template>
  <div class="min-w-80 flex flex-col items-center justify-between border-1px border-surface-700 rounded-6 bg-white p-4 font-sans shadow-sm">
    <div class="w-full flex flex-col">
      <div
        class="mb-3 flex items-center justify-center overflow-hidden rounded-16px sm:(h-290px w-full) xs:max-sm:(w-full)"
      >
        <img
          v-if="imageSource"
          class="aspect-square h-full min-h-full min-w-full w-full flex-shrink-none object-contain"
          :src="imageSource"
          :alt="props.product?.name"
        >
        <div
          v-else
          class="aspect-square h-full min-h-full min-w-full w-full flex flex-shrink-none items-center justify-center rounded bg-surface-600"
          alt=""
        >
          <DSIcon
            icon="i-far-image"
            class="text-text-200"
            size="48"
          />
        </div>
      </div>
      <div class="mb-6 w-full flex flex-col items-start">
        <p class="line-clamp-3 mb-2 text-18px text-secondary-400 font-600">
          {{ props.product?.name }}
        </p>
        <div class="flex gap-1 text-18px text-secondary-400 font-400">
          <span>{{ props.product?.price_range?.min?.string }}</span>
          <div
            v-if="isPriceRange"
            class="flex gap-1"
          >
            <span>&dash;</span>
            <span>{{ props.product?.price_range?.max?.string }}</span>
          </div>
        </div>
      </div>
    </div>

    <slot name="actions">
      <div class="w-full flex justify-between">
        <DSButton
          class="w-full flex cursor-pointer items-center justify-center rounded-40px bg-surface-400 px-16px py-8px text-16px text-text-400 font-600 active:bg-surface-600 focus:bg-surface-600 hover:bg-surface-600"
          @click="addToCart"
        >
          {{ t('View Product') }}
        </DSButton>
      </div>
    </slot>
  </div>
</template>

<i18n>
{
  "en-us": {
    "View Product": "View Product"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "View Product": "Produkt anzeigen"
}
</i18n>

<i18n locale="es" lang="json">
{
  "View Product": "Ver producto"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "View Product": "Voir le produit"
}
</i18n>
